import { computed, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FeedbackDialogHost } from '@jfw/angular/shared/common-components/feedback';
import {
  FeedbackClientContext,
  FeedbackSubmitRequest,
  FeedbackSubmitResponse,
  FeedbackUserTypeEnum,
} from '@jfw/types';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { FeedbackApiService } from './feedback-api.service';
import { FeedbackContextService } from './feedback-context.service';

/** EXT-6239: Platform Portal's side of the shared feedback dialog. */
@Injectable({ providedIn: 'root' })
export class PlatformFeedbackDialogHost implements FeedbackDialogHost {
  private readonly feedbackApi = inject(FeedbackApiService);
  private readonly contextService = inject(FeedbackContextService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  public readonly userType = FeedbackUserTypeEnum.PlatformUser;
  public readonly teamName = 'Platform Portal team';
  public readonly user = computed(() => {
    const platformUser = this.authService.platformUser();
    return platformUser
      ? { name: platformUser.displayName ?? '', email: platformUser.email }
      : null;
  });

  public snapshot(): FeedbackClientContext {
    return this.contextService.snapshot();
  }

  public submit(
    request: FeedbackSubmitRequest,
  ): Observable<FeedbackSubmitResponse> {
    return this.feedbackApi.submit(request);
  }

  /** EXT-6244: the submitter's own feedback. */
  public openMyFeedback(): void {
    this.router.navigate(['/my-feedback']);
  }
}
